<template>
  <div>
    <oil-form v-if='loading'
              :title='title'
              :items='empowerment'
              :createForm='!empowerment.Id'
              :keys='keys'
              :formCallback='formCallback'
              @SupplierId='changeSupplier'
              @ContractId='changeContract'
    >
      <template v-slot:File='{input}'>
        <v-file-input
            @change='file'
            :disabled='!input.isEdit'
            :label='label'
            dense outlined
        />
      </template>
      <template v-slot:Download='{input}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn style='box-shadow: none;color: #00b24f;background-color: transparent' :disabled='!input.isEdit'
                   @click='dow(empowerment)'
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Скачать</span>
        </v-tooltip>
      </template>
    </oil-form>
  </div>
</template>

<script>
import keys from './setting/coming_empowerment.json'
import { coreApi } from '~/services/core'
import { fileService } from '~/services/FileNextNumberService'

export default {
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    DatePicker: () => import('@/components/helper/form/oil.date.picker')
  },
  props: {
    id: String
  },
  data() {
    return {
      loading: false,
      title: 'Создать доверенность',
      empowerment: {
        Supplier: {},
        Contract: {},
        Attachment: {},
        File: {},
        Comment: '',
        Number: '',
        StartDate: '',
        EndDate: '',
        Status: '',
        LimitInTonnes: '',
        EmpowermentFullName: '',
        PassportNumber: ''
      },
      suppliers: [],
      contracts: [],
      keys: keys,
      label: 'Загрузить файл'
    }
  },
  async created() {
    const suppliers = await coreApi.get('suppler')
    this.suppliers = suppliers.data || []

    if (this.id) {
      this.title = 'Инфо о доверенности'
      const empowerment = await coreApi.get(`coming-empowerment?id=${this.id}`)
      this.label = empowerment.data?.Attachment?.Name || 'загрузить файл'
      this.empowerment = empowerment.data
      this.contracts = this.empowerment.Supplier.Contracts
    }

    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? coreApi.put : coreApi.post
    },
    message() {
      return this.id ? 'доверенност удачно изменен' : 'доверенност удачно создан'
    }
  },
  methods: {
    async formCallback(data, input, form, func) {

      input.isEdit = false

      const response = await this.storeType('coming-empowerment', data)

      if (!response.data) {
        input.isEdit = true
        return;
      }

      this.empowerment = response.data

      func(this.message)
      if (!this.id) {
        await this.$router.push({
          name: 'coming-empowerment',
          params: { id: this.empowerment.Id }
        })
      }

    },
    changeSupplier(supplier) {
      if (!supplier) return
      const contracts = supplier.Contracts
      this.empowerment.Supplier = { ...supplier }
      this.contracts = contracts
    },
    changeContract(contract) {
      if (!contract) return
      this.empowerment.Contract = { ...contract }
    },
    async file(file) {
      const fileId = await fileService.generateId()
      const res = await fileService.upload(fileId.data.Id, file)
      this.empowerment.Attachment = res.data
    }
  },
  watch: {
    suppliers(suppliers) {
      this.keys['Supplier.Id'].attrs.items = suppliers
    },
    contracts(contracts) {
      this.keys['Contract.Id'].attrs.items = contracts
    }
  }
}
</script>